module.exports = __webpack_public_path__ + "static/16.1_Early_Middle_Ages-2c6f7005634db00a1287bed2785cfb44.pdf";